export default __webpack_public_path__ + "0bb724d9042d8cae6271439277f38adc.png";